import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
 import Icon from'../../components/AppIcon';
 import Button from'../../components/ui/Button';

const SubscriptionSuccess = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          navigate('/dashboard')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [navigate])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8 inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-500/10">
          <Icon name="CheckCircle" size={48} className="text-green-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-foreground mb-4 font-heading">
          Subscription Activated!
        </h1>
        
        <p className="text-lg text-muted-foreground mb-8">
          Your subscription has been successfully activated. You now have access to all premium features.
        </p>

        <div className="bg-card border border-border rounded-xl p-6 mb-8">
          <p className="text-sm text-muted-foreground mb-2">
            Redirecting to dashboard in
          </p>
          <p className="text-4xl font-bold text-primary">{countdown}</p>
        </div>

        <Button
          variant="default"
          size="lg"
          onClick={() => navigate('/dashboard')}
          iconName="ArrowRight"
          iconPosition="right"
          className="w-full"
        >
          Go to Dashboard Now
        </Button>
      </div>
    </div>
  )
}

export default SubscriptionSuccess